import React from "react";
import KnowledgeAssistantPanel from "./KnowledgeAssistantPanel";

/**
 * Layout wrapper for every "Manage ESG Reporting" page: the page content on the
 * left, the docked Knowledge Base assistant on the right. On large screens the
 * expanded assistant is a real column and the content shrinks to fit; on small
 * screens it overlays from the right. Used by ReportManagementHub and by
 * ReportingStepFrame (which wraps each step route).
 */
export default function ReportManagementShell({ children }) {
  return (
    <div className="rm-shell">
      <div className="rm-shell__main">{children}</div>
      <KnowledgeAssistantPanel />
    </div>
  );
}
